(function () {
  'use strict';

  angular
    .module('factories.quizAnswerStorage', ['factories.storage'])
    .factory('QuizAnswerStorage', QuizAnswerStorage);

  QuizAnswerStorage.$inject = ['Storage'];

  function QuizAnswerStorage(Storage) {

    var previewMode = false;
    var cModuleStateId = 0;

    function internalId(id) {
      return cModuleStateId + '-' + id;
    }

    function answersKey() {
      return previewMode ? "quizAnswersPreview" : "quizAnswers";
    }

    function getIndex(items, id) {
      var len = items.length;
      if (len === 0)
        return -1;

      id = internalId(id);
      for (var i = 0; i < len; i++) {
        if (items[i].id == id)
          return i;
      }

      return -1;
    }

    var answerArrayLimit = 200;

    function setQuestionAnswer(id, answer, modified) {
      var answers = Storage.getValue(answersKey()) || [];

      var idx = getIndex(answers, id);
      if (idx > -1)
        answers.splice(idx, 1);

      answers.unshift({
        id: internalId(id),
        modified: modified,
        answer: answer
      });

      Storage.setValue(answersKey(), answers.slice(0, answerArrayLimit));
    }

    function clearQuestionAnswer(id) {
      var answers = Storage.getValue(answersKey()) || [];

      var idx = getIndex(answers, id);
      if (idx == -1) return;

      answers.splice(idx, 1);
      Storage.setValue(answersKey(), answers);
    }

    function getQuestionAnswer(id) {
      var answers = Storage.getValue(answersKey()) || [];

      var idx = getIndex(answers, id);
      if (idx > -1)
        return answers[idx];

      return null;
    }

    function clearPreviewAnswers() {
      Storage.setValue(answersKey(), []);
    }

    function setPreviewMode() {
      previewMode = true;
      clearPreviewAnswers();
    }

    function setCModuleStateId(id) {
      cModuleStateId = id;
    }

    var labellingImagesLimit = 100;
    var labelingImagesOrderKey = "labelingImagesOrder";

    function setLabelingImagesOrder(id, order) {
      var items = Storage.getValue(labelingImagesOrderKey) || [];

      var idx = getIndex(items, id);
      if (idx > -1)
        items.splice(idx, 1);

      items.unshift({
        id: internalId(id),
        order: order
      });

      Storage.setValue(labelingImagesOrderKey, items.slice(0, labellingImagesLimit));
    }

    function getLabelingImagesOrder(id) {
      var items = Storage.getValue(labelingImagesOrderKey) || [];

      var idx = getIndex(items, id);
      if (idx > -1)
        return items[idx];

      return null;
    }

    return {
      setQuestionAnswer: setQuestionAnswer,
      getQuestionAnswer: getQuestionAnswer,
      clearQuestionAnswer: clearQuestionAnswer,
      setLabelingImagesOrder: setLabelingImagesOrder,
      getLabelingImagesOrder: getLabelingImagesOrder,
      clearPreviewAnswers: clearPreviewAnswers,
      setPreviewMode: setPreviewMode,
      setCModuleStateId: setCModuleStateId
    };
  }

})();
